export const version = "wordlists/5.6.1";
//# sourceMappingURL=_version.js.map